module.exports = __webpack_public_path__ + "fonts/opensans-bold-webfont.0a2ae630.eot";